import { render, staticRenderFns } from "./SpD_Details.vue?vue&type=template&id=24a8c4e5"
import script from "./SpD_Details.vue?vue&type=script&lang=js"
export * from "./SpD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports